import React, { useEffect, useState } from 'react';
import { jsPDF } from 'jspdf';
import { Link } from 'react-router-dom';
import './Admin.css';
function Admin() {
  const [mediaList, setMediaList] = useState([]);
  const [selectedDoc, setSelectedDoc] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [currentTitle, setCurrentTitle] = useState('');
  const [filter, setFilter] = useState('all');
  const [contributorFilter, setContributorFilter] = useState('');

  useEffect(() => {
    fetch('/media')
      .then(res => res.json())
      .then(data => setMediaList(data));
  }, []);

  const generateDoc = async (media) => {
    setCurrentTitle(media.title);
    const response = await fetch('/generate-doc', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ title: media.title, location: media.location })
    });

    const data = await response.json();
    setSelectedDoc(data.documentary);
    setShowModal(true);
  };

  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text(currentTitle, 10, 20);
    doc.setFontSize(12);
    doc.text(selectedDoc, 10, 30);
    doc.save(`${currentTitle.replace(/\s+/g, '_')}_documentary.pdf`);
  };

  const getMediaType = (fileName) => {
    const ext = fileName.split('.').pop().toLowerCase();
    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return 'image';
    if (["mp4", "webm", "ogg"].includes(ext)) return 'video';
    return 'file';
  };

  const filteredMedia = mediaList.filter(media => {
    const type = getMediaType(media.file_path || media.location);
    const matchesType =
      (filter === 'videos' && type === 'video') ||
      (filter === 'images' && type === 'image') ||
      filter === 'all';
    const matchesContributor = contributorFilter
      ? (media.user || '').toLowerCase().includes(contributorFilter.toLowerCase())
      : true;
    return matchesType && matchesContributor;
  });

  const filterOptions = [
    { id: 'all', label: 'Toutes les Épingles' },
    { id: 'videos', label: 'Vidéos' },
    { id: 'images', label: 'Images' }
  ];

  return (
    <div className="d-flex flex-column" style={{ paddingTop: '100px' }}>
      <div className="p-3 bg-white border-bottom d-flex flex-wrap justify-content-between align-items-center gap-3">
        <div className="d-flex flex-wrap align-items-center gap-3">
          {filterOptions.map(option => (
            <div
              key={option.id}
              className={`badge rounded-pill px-4 py-2 ${filter === option.id ? 'bg-dark text-white' : 'bg-light text-dark border'}`}
              style={{ cursor: 'pointer', fontSize: '1rem' }}
              onClick={() => setFilter(option.id)}
            >
              {option.label}
            </div>
          ))}
          <input
            type="text"
            className="form-control ms-2"
            style={{ maxWidth: 250, borderRadius: '30px', padding: '8px 16px', fontSize: '1rem' }}
            placeholder="🔍 Rechercher un contributeur"
            value={contributorFilter}
            onChange={(e) => setContributorFilter(e.target.value)}
          />
        </div>
      </div>

      <div className="flex-grow-1 p-4">
        <div
          className="masonry-grid"
          style={{
            columnCount: 4,
            columnGap: '1rem'
          }}
        >
          {filteredMedia.map((media, index) => {
            const contributorUsername = media.user || 'unknown';
            const profileLink = `/users/${contributorUsername}`;
            const filePath = media.file_path || media.location;
            const isFromMedia = media.file_path !== undefined;
            const mediaURL = `${isFromMedia ? '/uploads/' : '/output/'}${filePath}`;

            return (
              <div key={index} style={{ breakInside: 'avoid', marginBottom: '1rem' }}>
                <div className="card shadow-sm">
                  {getMediaType(filePath) === 'image' ? (
                    <img
                      src={mediaURL}
                      alt={media.title}
                      style={{ width: '100%', borderRadius: '12px', display: 'block' }}
                    />
                  ) : (
                    <video
                      src={mediaURL}
                      controls
                      style={{ width: '100%', borderRadius: '12px', display: 'block' }}
                    />
                  )}

                  <div className="card-body d-flex flex-column justify-content-end" style={{ minHeight: '100px' }}>
                    <h6 className="mb-1 fw-semibold">{media.title}</h6>
                    <div className="small">
                      <Link
                        to={profileLink}
                        className="text-decoration-none"
                        style={{
                          fontSize: '0.875rem',
                          color: 'black',
                          cursor: 'pointer',
                          transition: 'color 0.2s ease, text-decoration 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.color = '#555';
                          e.target.style.textDecoration = 'underline';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.color = 'black';
                          e.target.style.textDecoration = 'none';
                        }}
                      >
                        @{contributorUsername}
                      </Link>

                      {media.created_at && (
                        <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                          Ajouté le {new Date(media.created_at).toLocaleDateString('fr-FR', {
                            day: 'numeric',
                            month: 'long',
                            year: 'numeric'
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Admin;
